import { oidcConfig } from '@src/Common/Constants/Auth.OidcConfig';
import axios from 'axios';
import { makeAutoObservable } from 'mobx';
import { User, UserManager } from 'oidc-client-ts';
import { UserInfoType } from './User.type';

export interface IUserStore {
  user: User | null;
  token?: string;
  isDetectedAction: boolean;
  adminAccountData: UserInfoType;
  errorInfo: string;
  loadUserManager: () => void;
  updateDetectedAction: (_status: boolean) => void;
  getAccountData: (_token: string) => void;
}

export class UserStore implements IUserStore {
  _user: User | null = null;
  _token?: string = undefined;
  _role = '';
  _userManager = new UserManager(oidcConfig);
  adminAccountData: UserInfoType = {} as UserInfoType;
  isDetectedAction = false;
  errorInfo = '';

  constructor() {
    makeAutoObservable(this);
    this.loadUserManager();
  }

  get user() {
    return this._user;
  }

  get token() {
    return this._token;
  }

  async loadUserManager() {
    try {
      const user = await this._userManager.getUser();
      this._user = user;
      this._token = user?.access_token;
    } catch (err) {
      this._user = null;
      this._token = undefined;
    }
  }

  async getAccountData(_token: string) {
    await axios
      .get(`${process.env.SSO_DOMAIN}Connect/UserInfo`, {
        headers: {
          Authorization: `Bearer ${_token}`
        }
      })
      .then((result) => {
        this.adminAccountData = result.data;
      })
      .catch((e) => {
        this.errorInfo = JSON.stringify(e);
      });
  }

  async updateDetectedAction(_status: boolean) {
    this.isDetectedAction = _status;
  }
}

export const UserStoreDefault: IUserStore = {
  user: null,
  token: undefined,
  isDetectedAction: false,
  adminAccountData: {} as UserInfoType,
  errorInfo: '',
  loadUserManager: () => null,
  updateDetectedAction: () => null,
  getAccountData: function (): void {
    throw new Error('Function not implemented.');
  }
};
